export const hasFieldLevelPermissionRestrictions = property => property.getIn(['fieldLevelPermission', 'accessLevel']) === 'hidden';
export const getPropertyType = property => property.get('type');
export const getDateDisplayHint = property => property.get('dateDisplayHint');